$(document).ready(function () {
    var AddEditCaseModal          = $('#addeditCaseModal');
    var DeleteCaseModal           = $('#deleteCaseModal');
    var CaseLogForm               = $('#CaseLogForm');
    var SubmitReflectionModal     = $('#submitReflectionForm');
    var AddEditReflectionModal    = $('#addeditReflectionModal');
    var ViewReflectionModal       = $('#ViewReflectionModal');
    var ReflectionFeedbackModal   = $('#ReflectionFeedbackModal');
    var EditReflectionModal       = $('#EditReflectionModal');
    var AddEditLearningGoal       = $('#addeditLearningGoalModal');
    var DeleteLearningGoalModal   = $('#deleteLearningGoalModal');
    var TutorMarkModal            = $('#TutorMarkModal');
    var EditTutorMarkModal        = $('#EditTutorMarkModal');
    var RevertReflectionModal     = $('#revertReflectionModal');
    var AddPersonalFileModal      = $('#AddPersonalFileModal');
    var deleteFileModal           = $('#deleteFileModal');
    var SubmissionFeedbackModal   = $('#SubmissionFeedbackModal');
    var AddEditExperience         = $('#AddEditExperienceModal');
    var DeleteExperienceModal     = $('#deleteExperienceModal');

    $.validator.addMethod('exactlength', function (value, element, param) {
        return this.optional(element) || value.length == param;
    });

    $(CaseLogForm).validate({
        rules: {
            block: {
                required: true,
                digits: true,
            },
            date_of_case: {
                required: true,
                exactlength: 10,
            },
            title: {
                required: true,
            },
            story: {
                required: true,
            },
            learning_points: {
                required: true,
            },
        },
        messages: {
            block: {
                required: 'Block is required',
            },
            date_of_case: {
                required: 'Please choose the date of your activity',
                exactlength: 'Please enter a date in the format dd/mm/yyyy',
            },
            title: {
                required: 'Please enter a title for your activity',
            },
            story: {
                required: 'Please enter your clinical story',
            },
            learning_points: {
                required: 'Please enter your learning points',
            },
        },
        submitHandler: function (form) {
            form.submit();
        },
    });

    $('#mypersonalForm').validate({
        rules: {
            title: {
                required: true,
            },
            userfile: {
                required: true,
            },
        },
        messages: {
            title: {
                required: 'Please give your file a title',
            },
            userfile: {
                required: 'Please upload your file',
            },
        },
    });

    $('#AddEditExperienceForm').validate({
        rules: {
            acyr: 'required',
            block: 'required',
            topic_id: 'required',
            title: 'required',
            content: 'required',
        },
        messages: {
            acyr: 'No academic year is defined',
            block: 'No block is defined',
            topic_id: 'No Topic ID is defined',
            title: 'Please enter a title for your experience',
            content: 'Please enter your experience',
        },
    });

    $('.new-goal').on('click', function () {
        AddEditLearningGoal.modal('show');
        AddEditLearningGoal.find('input[type=hidden][name="goal_id"], input[type=text], textarea').val('').change();
        var lna_id = $(this).parent().find('input[type="hidden"][name="id"]').val();
        $('input[type="hidden"][name="lna_id"]').val(lna_id);
    });

    $('.editgoal-btn').on('click', function () {
        event.preventDefault();
        AddEditLearningGoal.modal('show');
        var goal = $(this).parents('.goal-row').data('goal');
        $('input[type="hidden"][name="goal_id"]').val(goal.id);
        $('textarea[name="needstodevelop"]').val(goal.needstodevelop);
        $('textarea[name="achievedby"]').val(goal.achievedby);
        $('textarea[name="actions"]').val(goal.actions);
        $('textarea[name="progress"]').val(goal.progress);
    });

    $('.deletegoal-btn').on('click', function () {
        event.preventDefault();
        DeleteLearningGoalModal.modal('show');
        var goal = $(this).parents('.goal-row').data('goal');
        $('p.lna_needstodevelop').empty().append('<h4>What learning goal do you need to develop?</h4>' + goal.needstodevelop);
        $('p.lna_achievedby').empty().append('<h4>How will you achieve this?</h4>' + goal.achievedby);
        $('p.lna_actions').empty().append('<h4>What actions are you going to take to ensure you achieve you learning goal?</h4>' + goal.actions);
        $('p.lna_progress').empty().append('<h4>Progress</h4>' + goal.progress);
        $('input[type="hidden"][name="id"]').val(goal.id);
    });

    $('.new-caselog').on('click', function () {
        AddEditCaseModal.modal('show');
        AddEditCaseModal.find('input[type=hidden][name="id"], input[type=text], textarea').val('').change();
    });

    $('.deletecaselog-btn').on('click', function () {
        DeleteCaseModal.modal('show');
        var log = $(this).parents('.log-row').data('log');
        $('p.topic').empty().append('<h4>Topic/Block</h4>' + log.name + ' (Block ' + log.block + ')');
        $('p.title').empty().append('<h4>Title</h4>' + log.title);
        $('p.date_of_case').empty().append('<h4>Date of Activity</h4>' + dayjs.unix(log.date_of_case).format(SHORTDATE));
        $('p.story').empty().append('<h4>Clinical Story</h4>' + log.story);
        $('p.learning_points').empty().append('<h4>Learning Points</h4>' + log.learning_points);
        $('input[type="hidden"][name="id"]').val(log.id);
    });

    $('.editcaselog-btn').on('click', function () {
        AddEditCaseModal.modal('show');
        var log = $(this).parents('.log-row').data('log');
        $('input[type="hidden"][name="id"]').val(log.id);
        $('input[type="hidden"][name="acyr"]').val(log.acyr);
        $('input[type="hidden"][name="block"]').val(log.block);
        $('input[type="text"][name="title"]').val(log.title);
        $('input[type="text"][name="date_of_case"]').val(dayjs.unix(log.date_of_case).format('DD/MM/YYYY'));
        $('textarea[name="story"]').val(log.story);
        $('textarea[name="learning_points"]').val(log.learning_points);
        $('textarea[name="private_notes"]').val(log.private_notes);
    });

    $('.new-reflectionlog').on('click', function () {
        AddEditReflectionModal.modal('show');
        AddEditReflectionModal.find('input[type=hidden][name="id"], input[type=text], textarea').val('').change();
    });

    $('.editreflectionlog-btn').on('click', function () {
        AddEditReflectionModal.modal('show');
        var reflection = $(this).parents('.reflection-row').data('reflection');
        $('input[type="hidden"][name="id"]').val(reflection.id);
        $('input[type="hidden"][name="acyr"]').val(reflection.acyr);
        $('input[type="hidden"][name="block"]').val(reflection.block);
        $('textarea[name="reflection_text"]').val(reflection.reflection_text);
    });

    $('.submitreflectionlog-btn').on('click', function () {
        SubmitReflectionModal.modal('show');
        var reflection = $(this).parents('.reflection-row').data('reflection');
        $('p.title').empty().append('<h4>Title</h4>' + reflection.title);
        $('p.date_of_case').empty().append('<h4>Date of Activity</h4>' + dayjs.unix(reflection.date_of_case).format(SHORTDATE));
        $('p.reflection').empty().append('<h4>Reflection</h4>' + reflection.reflection_text);
        $('input[type="hidden"][name="id"]').val(reflection.id);
    });

    $('.viewreflectionlog-btn').on('click', function () {
        ViewReflectionModal.modal('show');
        var reflection = $(this).parents('.reflection-row').data('reflection');
        $('.topic').empty().append(reflection.topicname);
        $('p.reflection').empty().append('<h4>Reflection</h4>' + reflection.reflection_text);
    });

    $('.viewreflectionfeedback-btn').on('click', function () {
        ReflectionFeedbackModal.modal('show');
        var reflection = $(this).parents('.reflection-row').data('reflection');
        $('span.topic').empty().append(reflection.topicname);
        $('span.tutorname').empty().append('(' + reflection.tutorname + ')');
        $('p.posted span').empty().append(dayjs.unix(reflection.feedbackdate).format('MMMM Do YYYY LT'));
        $('p.feedback').empty().append(reflection.feedback);
        $('p.grade').empty().append(reflection.grade);
        $('.above_expectations, .meets_expectations, .below_expectations').hide();
        switch (reflection.grade) {
            case 'Above Expectations':
                $('.above_expectations').show();
                break;
            case 'Meets Expectations':
                $('.meets_expectations').show();
                break;
            case 'Below Expectations':
                $('.below_expectations').show();
                break;
        }
    });

    $('.editreflectionfeedback-btn').on('click', function () {
        EditReflectionModal.modal('show');
        var reflection = $(this).parents('.reflection-row').data('reflection');
        $('input[type="hidden"][name="id"]').val(reflection.feedback_id);
        $('input[type="hidden"][name="reflection_id"]').val(reflection.id);
        $('textarea[name="feedback"]').val(reflection.feedback);
        $('input[type="radio"][name="grade"][value="' + reflection.grade + '"]').prop('checked', 'checked');
        $('.above_expectations, .meets_expectations, .below_expectations').hide();
        $('input[type="radio"][name="grade"]').change(function () {
            switch ($(this).val()) {
                case 'Above Expectations':
                    $('.above_expectations').show();
                    $('.meets_expectations, .below_expectations').hide();
                    break;
                case 'Meets Expectations':
                    $('.meets_expectations').show();
                    $('.above_expectations, .below_expectations').hide();
                    break;
                case 'Below Expectations':
                    $('.below_expectations').show();
                    $('.above_expectations, .meets_expectations').hide();
                    break;
            }
        });
    });

    $('.revertreflectionlog-btn').on('click', function () {
        RevertReflectionModal.modal('show');
        var reflection = $(this).parents('.reflection-row').data('reflection');
        $('input[type="hidden"][name="reflection_id"]').val(reflection.id);
        $('input[type="hidden"][name="feedback_id"]').val(reflection.feedback_id);
    });

    $('.viewtutormark-btn').on('click', function () {
        TutorMarkModal.modal('show');
        const feedback = $(this).parents('.feedback-row').data('feedback');
        const topicSplit = $(this).parents('.feedback-row').data('topicsplit');

        if (topicSplit) {
            $('span.topic').empty().append(topicSplit + ' Feedback');
        } else {
            $('span.topic').empty().append(feedback.topicname);
        }

        if (feedback.grade[topicSplit] === undefined) {
            $('span.tutorname').empty().append('(' + feedback.tutorname + ')');
            $('p.posted span').empty().append(dayjs.unix(feedback.lastmodifieddate).format('MMMM Do YYYY LT'));
            $('p.grade').empty().append('<strong>Mark:</strong> ' + feedback.grade);
            $('p.feedback').empty().append(feedback.feedback);
        } else {
            $('span.tutorname').empty().append('(' + feedback.tutorname[topicSplit] + ')');
            $('p.posted span').empty().append(dayjs.unix(feedback.lastmodifieddate[topicSplit]).format('MMMM Do YYYY LT'));
            $('p.grade').empty().append('<strong>Mark:</strong> ' + feedback.grade[topicSplit]);
            $('p.feedback').empty().append(feedback.feedback[topicSplit]);
        }
    });

    const feedbackTextArea = $('#feedbackTutorFinal');
    const notApplicableCheckbox = $('#eob_not_applicable');
    const notApplicableText = 'This block has been marked as not applicable';

    let eportfolioFeedback = null;
    let newFeedback = null;
    let selectedRadio = null;

    $('#not-applicable-warning').hide();

    function updateFeedbackTextArea() {
        const isNotApplicableChecked = notApplicableCheckbox.prop('checked');

        if (isNotApplicableChecked) {
            selectedRadio = $('input[name="eob_grade"]:checked').val();

            $('input[name="eob_grade"]').prop('disabled', true).prop('checked', false);
            feedbackTextArea.val(notApplicableText).prop('disabled', true);
            $('#not-applicable-warning').show();
        } else {
            $('input[name="eob_grade"]').prop('disabled', false);
            $('#not-applicable-warning').hide();

            if (selectedRadio) {
                $('input[name="eob_grade"][value="' + selectedRadio + '"]').prop('checked', true);
                selectedRadio = null;
            }

            let displayFeedback = newFeedback || (eportfolioFeedback && eportfolioFeedback.feedback !== notApplicableText ? eportfolioFeedback.feedback : '');
            feedbackTextArea.val(displayFeedback).prop('disabled', false);
        }
    }

    $('.edittutormark-btn').on('click', function () {
        EditTutorMarkModal.modal('show');

        const topicSplitName = this.id;
        if (topicSplitName !== '') {
            $('input[type="hidden"][name="topic_split_name"]').val(topicSplitName);
            $('#tutor-mark-title').html('<i class="' + FontAwesome.prefix('regular', 'comments') + '"></i>' + topicSplitName + ' - Final Mark/Feedback');
        }

        eportfolioFeedback = $(this).parents('.feedback-row').data('feedback');

        const hasFeedback = eportfolioFeedback !== undefined;

        $('input[type="hidden"][name="eob_id"]').val(hasFeedback ? eportfolioFeedback.id : null);
        notApplicableCheckbox.prop('checked', hasFeedback && eportfolioFeedback.grade === 'Not Applicable');

        if (hasFeedback) {
            $('input[type="radio"][name="eob_grade"]').prop('checked', function () {
                return $(this).val() === eportfolioFeedback.grade;
            });
            feedbackTextArea.val(eportfolioFeedback.feedback).prop('disabled', eportfolioFeedback.grade === 'Not Applicable');
        } else {
            $('input[type="radio"][name="eob_grade"]').prop('checked', false);
            feedbackTextArea.val('').prop('disabled', false);
        }

        updateFeedbackTextArea();
    });

    feedbackTextArea.on('input', function () {
        newFeedback = $(this).val();
        updateFeedbackTextArea();
    });

    $('input[name="eob_grade"]').change(function () {
        updateFeedbackTextArea();
    });

    notApplicableCheckbox.change(function () {
        updateFeedbackTextArea();
    });

    $('.viewsubmissionfeedback-btn').on('click', function () {
        SubmissionFeedbackModal.modal('show');
        var file = $(this).parents('.file-row').data('file');
        $('span.title').empty().append(file.title);
        $('span.tutorname').empty().append('(' + file.feedback.lastmodifiedby_realname + ')');
        $('p.posted span').empty().append(dayjs.unix(file.feedback.createddate).format('MMMM Do YYYY LT'));
        if (file.feedback.grade != null) {
            $('p.grade').empty().append('<strong>Mark:</strong> ' + file.feedback.grade);
        }
        $('p.feedback').empty().append(file.feedback.feedback);
    });

    $('.savepersonalfile-btn').on('click', function () {
        AddPersonalFileModal.modal('show');
        AddPersonalFileModal.find('input[type=text]').val('').change();
    });

    $('.deletefile-btn').on('click', function () {
        deleteFileModal.modal('show');
        var file = $(this).parents('.file-row').data('file');
        if (file.status === 'Submitted') {
            $('div.deleteFile').show().empty().append('<h4 class="alert-heading">Warning</h4>' +
                '<p>You are about to delete this file which has been submitted for marking. Are you sure you wish to continue?</p><br>');
        } else {
            $('div.deleteFile').hide();
        }
        $('p.title').empty().append('<h4>Title</h4>' + file.title);
        $('input[type="hidden"][name="id"]').val(file.id);
    });

    $('.new-experience-btn').on('click', function () {
        AddEditExperience.modal('show');
        AddEditExperience.find('input[type=hidden][name="id"], input[type=text], textarea').val('').change();
    });

    $('.editexperience-btn').on('click', function () {
        AddEditExperience.modal('show');
        var experience = $(this).parents('.experience-row').data('experience');
        $('input[type="hidden"][name="id"]').val(experience.id);
        $('input[type="hidden"][name="acyr"]').val(experience.acyr);
        $('input[type="hidden"][name="block"]').val(experience.block);
        $('input[type="text"][name="title"]').val(experience.title);
        $('textarea[name="content"]').val(experience.content);
    });

    $('.deleteexperience-btn').on('click', function () {
        DeleteExperienceModal.modal('show');
        var experience = $(this).parents('.experience-row').data('experience');
        $('p.title').empty().append('<h4>Title</h4>' + experience.title);
        $('p.experience').empty().append('<h4>Experience</h4>' + experience.content);
        $('input[type="hidden"][name="id"]').val(experience.id);
    });

    $('.previewsubmission-btn').on('click', function () {
        var submissionId = $(this).attr('data-submissionId');
        var ajaxloading  = $('.ajaxloading');

        $.ajax({
            url: base_url + 'eportfolio/ajax_previewDocument',
            data: { submissionId: submissionId },
            dataType: 'json',
            delay: 250,
            type: 'GET',
            beforeSend: function () {
                $(ajaxloading).html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Loading User\'s Submission...');
            },
            success: function (data) {
                ajaxloading.empty();
                // Open a new window to display PDFs, and image files
                window.open(data.path);
            },
            error: function (xhr, status, error) {
                // Ajax request failed.
                ajaxloading.empty();
                var errorMessage = xhr.status + ': Request failed. Assignment submission not found.';
                alert('Error: ' + errorMessage);
            },
        });
    });

    $('[id^="collect-sparkforms-submission-"]').on('click', function () {
        var row        = $(this).closest('#submissionRow');
        var submission = JSON.parse(row.attr('data-submission'));

        $('input[type="hidden"][name="sparkforms_id"]').val(submission.id);
        $('input[type="hidden"][name="topic_id"]').val('');
        $('input[type="hidden"][name="block"]').val('');

        $('#collect-sparkforms-name').text(submission.form_name);
        $('#collect-sparkforms-id').text(submission.submission_id);

        $('#collect-sparkforms-modal').modal('show');

        $('#topic-id').trigger('change');
    });

    $('[id^="delete-sparkforms-submission-"]').on('click', function () {
        var row        = $(this).closest('#submissionRow');
        var submission = JSON.parse(row.attr('data-submission'));

        $('input[type="hidden"][name="sparkforms_id"]').val(submission.id);
        $('#delete-sparkforms-name').text(submission.form_name);
        $('#delete-sparkforms-id').text(submission.submission_id);

        $('#delete-sparkforms-modal').modal('show');
    });

    $('[id^="preview-sparkforms-submission-"]').on('click', function () {
        var row            = $(this).closest('#submissionRow');
        var submission     = JSON.parse(row.attr('data-submission'));
        var formFields     = JSON.parse(submission.form_fields_json);
        var submissionData = JSON.parse(submission.submission_json);
        var notSpecified   = 'Not Specified';

        $('#preview-sparkforms-name').text(submission.form_name || '');
        $('#preview-sparkforms-id').text(submission.submission_id || '');
        $('#preview-sparkforms-created-at').text(submission.created_at || '');
        $('#preview-sparkforms-last-modified-at').text(submission.last_modified_at || '');
        $('#preview-sparkforms-email').text(submission.user_email || '');

        var html = '';
        for (const field of formFields) {
            // Skip if no data was submitted for this field
            if (!Object.prototype.hasOwnProperty.call(submissionData, field.name)) {
                return;
            }

            var value        = submissionData[field.name];
            var escapeTitle  = $('<div>').text(field.title || field.name).html();

            html += '<strong>' + escapeTitle  + '</strong><br>';

            if (field.type === 'Checks' && Array.isArray(value)) {
                // If array is empty, show "Not Specified", otherwise show all checked items
                var items = value.length ? value : [notSpecified];
                html += '<ul>';
                for (const item of items) {
                    // Display each checkbox value as a bullet point
                    html += '<li>' + $('<div>').text(item || notSpecified).html() + '</li>';
                };
                html += '</ul>';
            } else if (typeof value === 'string' && /^iVBORw0KGgo|^data:image\//.test(value)) {
                // Display assessor signature
                html += '<img src="data:image/png;base64,' + value.replace(/^data:image\/png;base64,/, '') + '" alt="' + escapeTitle + '" class="max-w-full">';
            } else {
                html += $('<div>').text(value || notSpecified).html() + '<br>';
            }

            html += '<br>';
        };

        $('#preview-sparkforms-fields').html(html);
        $('#preview-sparkforms-modal').modal('show');
    });

    // Get block number from specialty dropdown
    $('#topic-id').on('change', function () {
        const selectedTopicText = $(this).find('option:selected').text();
        const blockMatch        = selectedTopicText.match(/\(Block\s+(\d+)\)/);
        const blockNumber       = blockMatch ? blockMatch[1] : '';

        $('input[name="block"]').val(blockNumber);
    });

    $('#date_of_case').datetimepicker({
        timepicker: false,
        format: 'd/m/Y',
        maxDate: '+1970/01/01',
    });
});
